import axios from "axios";

export class GeoApi {
  /**
   * Devuelve el código ISO del país detectado según la IP del usuario.
   * @returns {Promise<string|null>} Código de país en minúsculas o null si falla.
   */
  async getRegion() {
    try {
      const { data } = await axios.get("https://ipapi.co/json/");
      return data?.country_code ? data.country_code.toLowerCase() : null;
    } catch (_) {
      return null;
    }
  }
}

const geoApi = new GeoApi();
export default geoApi;